import { send } from 'server';

export const CONF = {
    'product-loss-limit': ['productLoss', 'Loss'],
    'product-bet-limit': ['productBet', 'Bet']
};

export const getProductLimits = ({ type: portletType }) => {
    const [type, name] = CONF[portletType];

    return send({
        type,
        ID: 35580,
        responses: [35581, 35582],
        description: `Get Player Product ${name} Limits`
    });
};

export const setProductLimits = ({ type: portletType, limits }) => {
    const [type, name] = CONF[portletType];

    return send({
        type,
        limits,
        ID: 35583,
        responses: [35584, 35585],
        description: `Set Player Product ${name} Limits`
    });
};
